export default {
    name: 'ButtonSave',
};